import api from '@/client/core/api'
import { APIError } from '@/typings/api/error'
import { PostCampaignTweetPostsBody } from '@/typings/campaigns'

import { CampaignTweetPostApiError } from './campaignTweetPostApiError'

// POST /campaigns/:campaignId/tweet-posts のレスポンス。
// アカウント不一致時はサーバが error(NOT_MATCH) を返す。不一致の内訳は返らない。
type PostCampaignTweetPostsResponse = {
  data?: boolean
  error?: APIError
}

export async function postCampaignTweetPosts(campaignId: number, urls: string[]): Promise<true> {
  const body: PostCampaignTweetPostsBody = { urls: urls as PostCampaignTweetPostsBody['urls'] }
  const response = await api.post<PostCampaignTweetPostsResponse>(`/campaigns/${campaignId}/tweet-posts`, body)

  if (response instanceof Error) {
    throw response
  }

  if (response?.error?.type) {
    throw new CampaignTweetPostApiError(response.error.type, response.error.message, response.error.status)
  }

  if (response?.data !== true) {
    throw new CampaignTweetPostApiError('INVALID_RESPONSE', '投稿URL保存APIのレスポンス形式が不正です。')
  }

  return true
}
